<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <!-- 余额充值 -->
          <div class="ttshop_recharge min_h">
            <div class="ttshop_rechargeup">
              <h5>余额充值</h5>
              <ul class="clearfloat">
                <li
                  class="d-flex align-items-center flex-direction-column justify-content-center"
                  v-for="(item, index) in list.list"
                  :key="index"
                  :class="{ active: index == num }"
                  @click="rechargetab(index)"
                >
                  <h4>
                    <span>{{ item.pay_price }}</span
                    >元
                  </h4>
                  <!-- <p>充值<span>{{item.}}</span>送<strong>10</strong></p> -->
                  <p>{{ item.name }}</p>
                </li>
                <!-- <li class="d-flex align-items-center flex-direction-column justify-content-center" :class="{active: 1 == num}" @click="rechargetab(1)">
                  <h4><span>400</span>元</h4>
                </li>
                <li class="d-flex align-items-center flex-direction-column justify-content-center" :class="{active: 2 == num}" @click="rechargetab(2)">
                  <h4><span>600</span>元</h4>
                </li>
                <li class="d-flex align-items-center flex-direction-column justify-content-center" :class="{active: 3 == num}" @click="rechargetab(3)">
                  <h4><span>1000</span>元</h4>
                  <p>充值<span>1000</span>送<strong>20</strong></p>
                </li> -->
              </ul>
            </div>
            <div class="ttshop_rechargecon">
              <h5>其他金额</h5>
              <input
                type="text"
                v-model="input"
                ref="input"
                v-on:input="inputFunc"
                placeholder="输入您想要充值的金额"
              />
            </div>
            <div class="ttshop_rechargebut">
              <h5>支付方式</h5>
              <ul class="clearfloat">
                <li
                  class="d-flex align-items-center justify-content-center"
                  :class="{ active: 0 == zhifu }"
                  @click="zhifus(0)"
                >
                  <i
                    ><img
                      class="img-default"
                      src="../../assets/images/ttshop_wxzf.png"
                      alt=""
                  /></i>
                  <span>微信支付</span>
                </li>
                <li
                  class="d-flex align-items-center justify-content-center"
                  :class="{ active: 1 == zhifu }"
                  @click="zhifus(1)"
                >
                  <i
                    ><img
                      class="img-default"
                      src="../../assets/images/ttshop_zfbzf.png"
                      alt=""
                  /></i>
                  <span>支付宝支付</span>
                </li>
              </ul>
            </div>
            <div class="ttshop_rechargelast">
              <button @click="submitBtn">充值</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ttshop_pay">
      <el-dialog
        title=""
        :visible.sync="shopVisible"
        :before-close="payContTypeChange"
      >
        <div class="pay-title d-flex align-items-center justify-content-center">
          微信支付￥{{ payNum }}
        </div>
        <div
          class="pay-qrcode d-flex align-items-center justify-content-center"
        >
          <div id="qrcode" ref="qrcode"></div>
        </div>
      </el-dialog>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
import QRCode from "qrcodejs2";
let Base64 = require("js-base64").Base64;
import "./user.css";
export default {
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      num: 0,
      zhifu: 0,
      list: "",
      input: "",
      shopVisible: false,
      payNum: "",
      time: "",
    };
  },
  mounted() {
    this.rechargeList();
  },
  methods: {
    // 选择充值金额
    rechargetab(index) {
      this.num = index;
      this.input = "";
    },
    // 支付方式
    zhifus(index) {
      this.zhifu = index;
    },
    // 展示数据
    rechargeList() {
      this.$api
        .rechargeList({})
        .then((res) => {
          this.list = res.data;
        })
        .catch((err) => {});
    },
    //输入框输入事件
    inputFunc() {
      let input = this.$refs.input.value;
      console.log(input);
      this.num = -1;
    },
    //提交
    submitBtn() {
      if (this.num == -1) {
        console.log(this.$refs.input.value);
        this.rechargeSubmit(this.$refs.input.value, 0);
        this.payNum = this.$refs.input.value;
      } else {
        console.log(this.list.list[this.num].pay_price);
        this.rechargeSubmit(
          this.list.list[this.num].pay_price,
          this.list.list[this.num].send_price
        );
        this.payNum = this.list.list[this.num].pay_price;
      }
    },
    //余额提交
    rechargeSubmit(payPic, sedPic) {
      let _this = this;
      let pay_type = "";
      let payurl = window.location.href;
      let payurls="";
      if (this.zhifu == 0) {
        pay_type = "WECHAT_PAY";
      } else {
        pay_type = "ALIPAY";
        payurls = payurl.split("#")[0] + '#/ttshop_mybalance';
      }
      console.log(pay_type);
      _this.$api
        .rechargeSubmit({
          pay_type: pay_type,
          send_price: sedPic,
          pay_price: payPic,
          return_url:payurls,
        })
        .then((res) => {
          if (_this.zhifu == 0) {
            _this.shopVisible = true;
            let url = Base64.decode(res.res.code_url);
            setTimeout(function () {
              _this.qrcodeScan(url);
            }, 100);
          } else {
            // window.sessionStorage.setItem("alipay_type", true);
            const div = document.createElement("div");
            div.innerHTML = res.data;
            document.body.appendChild(div);
            document.forms[0].submit();
          }
          // this.list = res.data
          _this.time = setInterval(() => {
            _this.orderStatus(res.res.order_no);
          }, 5000);
        })
        .catch((err) => {
          // this.user = err;
        });
    },
    qrcodeScan(url) {
      this.$refs.qrcode.innerHTML = "";
      //生成二维码
      let qrcode = new QRCode("qrcode", {
        width: 150, // 二维码宽度
        height: 150, // 二维码高度
        text: url,
      });
    },
    //订单状态
    orderStatus(order) {
      if (this.shopVisible == false) {
        clearInterval(this.time);
        console.log("123");
      }
      this.$api
        .orderStatus({
          order_no: "recharge_" + order,
        })
        .then((res) => {
          if (res.code == 0) {
            clearInterval(this.time);
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.shopVisible = false;
            this.$router.push("/ttshop_mybalance");
          }
        })
        .catch((err) => {});
    },
    // 支付二维码关闭
    payContTypeChange() {
      let that = this;
      that
        .$confirm("是否取消支付", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
        .then(() => {
          that.shopVisible = false;
          clearInterval(this.time);
          // that.$router.replace({
          //   path: "/ttshop_usermyorder",
          //   query: {},
          // });
        })
        .catch(() => {
          console.log("取消");
        });
    },
  },
};
</script>

<style  lang="scss" scoped>
.ttshop_recharge {
  width: 100%;
  background: #fff;
  padding: 40px;
  box-sizing: border-box;
  .ttshop_rechargeup {
    width: 100%;
    margin-bottom: 65px;
    h5 {
      font-size: 12px;
      color: #333;
      font-weight: 600;
      line-height: 12px;
      margin-bottom: 15px;
    }
    ul {
      li {
        float: left;
        width: 160px;
        height: 68px;
        border: 1px solid #ebebeb;
        background: #ebebeb;
        border-radius: 4px;
        margin-right: 20px;
        padding: 10px;
        box-sizing: border-box;
        cursor: pointer;
        position: relative;
        &::before {
          content: "";
          width: 12px;
          height: 12px;
          background: url(../../assets/images/xuanzhong.svg) center
            no-repeat;
          position: absolute;
          bottom: 0px;
          right: 0px;
          display: none;
        }
        &:last-child {
          margin-right: 0;
        }
        &.active {
          border-color: #ff3346;
          background: #fff0f1;
        }
        &.active h4 span {
          color: #ff0e25;
        }
        &.active::before {
          display: block;
        }
        h4 {
          width: 100%;
          font-size: 12px;
          color: #666;
          font-weight: 400;
          text-align: center;
          margin-bottom: 2px;
          span {
            font-size: 20px;
            color: #333;
            font-weight: 600;
            margin-right: 4px;
          }
        }
        p {
          width: 100%;
          text-align: center;
          font-size: 12px;
          color: #666;
          span {
            color: #666;
            font-size: 12px;
          }
          strong {
            font-weight: 500;
            font-size: 12px;
            color: #ff3346;
          }
        }
      }
    }
  }
  .ttshop_rechargecon {
    width: 100%;
    margin-bottom: 32px;
    h5 {
      font-size: 12px;
      color: #333;
      font-weight: 600;
      line-height: 12px;
      margin-bottom: 15px;
    }
    input {
      width: 275px;
      height: 32px;
      border: 1px solid #ebebeb;
      border-radius: 2px;
      font-size: 12px;
      color: #333;
      padding: 0 12px;
      box-sizing: border-box;
      outline: none;
      transition: 0.5s;
      -moz-transition: 0.5s;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;
      &:focus {
        border-color: #ff0e25;
      }
    }
  }
  .ttshop_rechargebut {
    width: 100%;
    margin-bottom: 56px;
    h5 {
      font-size: 12px;
      color: #333;
      font-weight: 600;
      line-height: 12px;
      margin-bottom: 15px;
    }
    ul {
      li {
        float: left;
        margin-right: 20px;
        border: 1px solid #ebebeb;
        width: 158px;
        height: 40px;
        border-radius: 4px;
        cursor: pointer;
        position: relative;
        padding: 5px;
        box-sizing: border-box;
        &::before {
          content: "";
          width: 12px;
          height: 12px;
          background: url(../../assets/images/xuanzhong.svg) center
            no-repeat;
          position: absolute;
          bottom: -1px;
          right: 0px;
          display: none;
        }
        &:last-child {
          margin-right: 0;
        }
        &.active {
          border-color: #ff3346;
        }
        &.active::before {
          display: block;
        }
        i {
          display: block;
          width: 27px;
          height: 24px;
          margin-right: 8px;
          img {
            display: block;
            width: 100%;
          }
        }
        span {
          font-size: 16px;
          color: #666;
          font-weight: 400;
          line-height: 16px;
        }
      }
    }
  }
  .ttshop_rechargelast {
    width: 100%;
    button {
      display: block;
      width: 116px;
      height: 32px;
      font-size: 14px;
      color: #fff;
      border-radius: 2px;
      outline: none;
      border: 0;
      cursor: pointer;
      background: #ff0e25;
      transition: 0.5s;
      -moz-transition: 0.5s;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;
      &:hover {
        box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
      }
    }
  }
}
.ttshop_pay {
  .pay-title {
    width: 100%;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .pay-qrcode {
    width: 200px;
    height: 200px;
  }
}
</style>
